import { _ as _inherits, a as _createSuper, b as _createClass, c as _classCallCheck, f as _wrapNativeSuper } from './_rollupPluginBabelHelpers-addb23d1.js';

var SectionFooter = /*#__PURE__*/function (_HTMLElement) {
  _inherits(SectionFooter, _HTMLElement);
  var _super = _createSuper(SectionFooter);
  function SectionFooter() {
    var _this;
    _classCallCheck(this, SectionFooter);
    _this = _super.call(this);
    _this.countChildren();
    return _this;
  }
  _createClass(SectionFooter, [{
    key: "countChildren",
    value: function countChildren() {
      var children = this.querySelectorAll(":scope > *");
      var counts = {
        above720: 0,
        below720: 0
      };
      children.forEach(function (child) {
        if (child.className.includes("hidden")) return; // If hidden class present, it is not visible at any size

        if (child.getAttribute("data-hide-below-720") !== "true") {
          counts.below720++;
        }
        counts.above720++;
      });
      this.setAttribute("data-children-visible-above-720", counts.above720);
      this.setAttribute("data-children-visible-below-720", counts.below720);
    }
  }, {
    key: "connectedCallback",
    value: function connectedCallback() {
      this.observer = new MutationObserver(this.countChildren.bind(this));
      this.observer.observe(this, {
        childList: true,
        subtree: true
      });
    }
  }, {
    key: "disconnectedCallback",
    value: function disconnectedCallback() {
      this.observer.disconnect();
    }
  }]);
  return SectionFooter;
}( /*#__PURE__*/_wrapNativeSuper(HTMLElement));
if (!customElements.get("section-footer-component")) {
  customElements.define("section-footer-component", SectionFooter);
}

function createFloatingHearts(button) {
  const rect = button.getBoundingClientRect(); 

  // Create a floating heart container inside the body
  const container = document.createElement("div");
  container.classList.add("heart-container");

  // Set absolute position of the container based on click position
  container.style.position = "fixed";
  container.style.left = `${rect?.left + 10}px`;
  container.style.top = `${rect?.top + 10}px`;
  container.style.transform = "translate(-50%, -50%)"; // Center the hearts

  // Create two hearts
  for (let i = 0; i < 2; i++) {
    const heart = document.createElement("div");
    heart.classList.add("floating-heart");
    heart.innerHTML = "❤️";
    heart.style.animationDelay = `${i * 0.2}s`; // Delay effect
    container.appendChild(heart);
  }

  document.body.appendChild(container); // Append to body instead of button

  // Remove after animation
  setTimeout(() => {
    container.remove();
  }, 1500);
}

// Attach event listener to buttons
document.addEventListener("DOMContentLoaded", function () {
  function attachWishlistListeners() {
    const buttons = document.querySelectorAll(".swym-wishlist-collections-v2");
    const button = document.querySelector("#swym-atw-pdp-button");

    buttons?.forEach((button) => {
      if (!button.dataset.listenerAdded) { // Prevent duplicate listeners
        button.dataset.listenerAdded = "true";

        button.addEventListener("click", function () {
          const svgPath = button.querySelector('path');
          if (svgPath && svgPath.getAttribute('fill') === 'none') {
            createFloatingHearts(button);
          }
          return false;
        });
      }
    });

    button?.addEventListener("click", function () {
      const svgPath = button.querySelector('path');
      if (svgPath && svgPath.getAttribute('fill') === 'none') {
        createFloatingHearts(button);
      }
      return false;
    });

    if (buttons.length > 0) {
      observer.disconnect(); // Stop observing once elements are found
    }
  }

  // Use MutationObserver to detect when elements are added to the DOM
  const observer = new MutationObserver(() => {
    attachWishlistListeners();
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // Run initially in case elements are already present
  attachWishlistListeners();
});

const moveInterval = setInterval(() => {
  const mobileContentWrapper = document.querySelector(".mobile-content-wrapper");
  const mobileBottomContent = document.querySelector(".mobile-bottom-content");

  if (mobileContentWrapper && mobileBottomContent && !mobileContentWrapper.contains(mobileBottomContent)) {
    mobileContentWrapper.appendChild(mobileBottomContent);
    clearInterval(moveInterval); // Stop the interval once moved
  }
}, 1200); // Runs every 500ms

export { SectionFooter as default };
